<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('Orders.title').toUpperCase()"
      />
      <h3
        class="subtitle is-5"
        v-text="$t('Common.filters')"
      />
    </div>
    <order-filters />
    <orders />
  </section>
</template>

<script>
import OrderFilters from '@/components/filters/OrderFilters'
import Orders from '@/components/dashboard/Orders'

export default {
  name: 'DashboardOrders',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  },
  beforeDestroy () {
    this.$eventBus.$off('getOrders')
    this.$eventBus.$off('onPageChange')
    this.$eventBus.$off('closeModal')
    this.$eventBus.$off('cleanFilters')
    this.$eventBus.$off('writeOrder')
    this.$eventBus.$off('openFilter')
    this.$eventBus.$off('selectOrderFilter')
  },
  components: {
    OrderFilters,
    Orders
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardOrders.vue